var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalidas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-walking-around",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-walking-around:not(.animated) .animable {opacity: 0;}svg#freepik_stories-walking-around.animated #freepik--Tree--inject-1 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-walking-around.animated #freepik--Character--inject-1 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "ele37rshwqhev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "el1fs8dfq1ke2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "eledxe9xruxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elqa3qbb77si",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "eloaw5jl3y57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elv7a1hkd68nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el90eu1gs35nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elpcb9sbf924g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "el4sxfjid5be",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.01,
    y: 253.28,
    width: 33.86,
    height: 63.91,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "134.94px 285.235px"
    },
    id: "elldc5rimtw8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.97,
    y: 258.79,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "146.8px 261.62px"
    },
    id: "elv84r25m99wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.26,
    y: 267.32,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.09px 270.15px"
    },
    id: "elr4ebja17hhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.07,
    y: 267.32,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "138.9px 270.15px"
    },
    id: "eloaw5zuig72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.97,
    y: 267.32,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "146.8px 270.15px"
    },
    id: "el4ex6e1xqhy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.16,
    y: 275.86,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "130.99px 278.69px"
    },
    id: "eljee5b11whj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.26,
    y: 284.39,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.09px 287.22px"
    },
    id: "elegixgdrfur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.07,
    y: 284.39,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "138.9px 287.22px"
    },
    id: "elarog0c2pl3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.97,
    y: 284.39,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "146.8px 287.22px"
    },
    id: "elbokg91gdry7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljpln5qu65t"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.97,
    y: 293.1,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "146.8px 295.93px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 128.16,
    y: 301.46,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "130.99px 304.29px"
    },
    id: "el2n4d7ab39gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.07,
    y: 301.46,
    width: 5.66,
    height: 5.66,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "138.9px 304.29px"
    },
    id: "elff1hwri13f6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.55 333.64 374.4 333.64 374.4 261.39 395.55 269.98 395.55 333.64",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "384.975px 297.515px"
    },
    id: "elovjbldb64yo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 268.86,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 270.455px"
    },
    id: "elva8s9jxdww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 273.67,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 275.265px"
    },
    id: "elgnm0osp1kiw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 278.48,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 280.075px"
    },
    id: "el516trbzbisj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 278.48,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 280.075px"
    },
    id: "el5ugebq7i937",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.6,
    y: 278.48,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.195px 280.075px"
    },
    id: "elxb2uwpezpw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 288.1,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 289.695px"
    },
    id: "eljk58qb874m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.6,
    y: 288.1,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.195px 289.695px"
    },
    id: "el6ebqbykfoqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 292.91,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 294.505px"
    },
    id: "elz510025n24g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 297.72,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 299.315px"
    },
    id: "ellzn7mjx9i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.6,
    y: 297.72,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.195px 299.315px"
    },
    id: "elgdlt99u9xc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.06,
    y: 297.72,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "391.655px 299.315px"
    },
    id: "elvq03i6zav4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 302.53,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 304.125px"
    },
    id: "el1m4ca3f2wc1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 307.34,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 308.935px"
    },
    id: "eljw2ez5nbk1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 307.34,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 308.935px"
    },
    id: "elu523x958ekb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.06,
    y: 307.34,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "391.655px 308.935px"
    },
    id: "eluat9s5o3yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln2qtgahwxdh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.7,
    y: 312.05,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "378.295px 313.645px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elscl9z0y8qk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.6,
    y: 312.18,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.195px 313.775px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell07rkr1ul48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.06,
    y: 312.24,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "391.655px 313.835px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 316.95,
    width: 3.19,
    height: 3.19,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "382.745px 318.545px"
    },
    id: "elkk9htqldjao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.67,152.81A6.21,6.21,0,0,0,413,154a9.36,9.36,0,0,0-13.17-11.54,9.36,9.36,0,0,0-18.12,3.29,10.36,10.36,0,0,0,.09,1.25,9.13,9.13,0,0,0-2.46-.34,9.37,9.37,0,1,0,0,18.73h37.33a6.29,6.29,0,0,0,0-12.58Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "396.312px 150.896px"
    },
    id: "el2j49eort1by",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,197.6a4.41,4.41,0,0,0-2.6.84,6.62,6.62,0,0,0-9.3-8.16,6.62,6.62,0,0,0-12.81,2.33,6.4,6.4,0,0,0,.07.88,6.7,6.7,0,0,0-1.74-.24,6.62,6.62,0,1,0,0,13.24h26.38a4.45,4.45,0,0,0,0-8.89Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.99px 196.248px"
    },
    id: "elqztekup4ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.24 289.18 421.24 285.24 413.27 285.24 413.27 289.18 400.05 289.18 400.05 358.36 423.17 358.36 423.17 289.18 421.24 289.18",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.61px 321.8px"
    },
    id: "elx6lou7e5vcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 294.16,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "409.225px 295.865px"
    },
    id: "elq0hqhdzwtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.28,
    y: 294.16,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "413.985px 295.865px"
    },
    id: "elx1gxmls216p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 299.31,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 301.015px"
    },
    id: "el044ppb596505",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 299.31,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "409.225px 301.015px"
    },
    id: "el1edo0p2z1he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 299.31,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "418.755px 301.015px"
    },
    id: "eloqkcp0o7x1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 304.46,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 306.165px"
    },
    id: "eldeu668a8mu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.28,
    y: 304.46,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "413.985px 306.165px"
    },
    id: "el7v5tx9180bt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 304.46,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "418.755px 306.165px"
    },
    id: "el5iwk8im4nvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 314.75,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 316.455px"
    },
    id: "el5e3kyoy70j3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.28,
    y: 314.75,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "413.985px 316.455px"
    },
    id: "elrz7w8jhnj3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 319.9,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 321.605px"
    },
    id: "elo8o4o09wbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 319.9,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "409.225px 321.605px"
    },
    id: "el9u45uvui4zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 319.9,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "418.755px 321.605px"
    },
    id: "eln6uvzv30aib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 325.05,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "418.755px 326.755px"
    },
    id: "elubqwa3l1ycr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 330.2,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 331.905px"
    },
    id: "elwvrkv5fqm9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.52,
    y: 330.2,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "409.225px 331.905px"
    },
    id: "elbu6en0tqo25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnt12k6wtttb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.28,
    y: 335.38,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "413.985px 337.085px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli948mi48d5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 335.45,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "418.755px 337.155px",
      transform: "rotate(0.82deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 402.75,
    y: 340.5,
    width: 3.41,
    height: 3.41,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.455px 342.205px"
    },
    id: "eluw2qjjuu0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,371.4,159.56,271.05a126,126,0,0,1,178.2,0L438.12,371.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "248.66px 302.77px"
    },
    id: "elgt0w7uczky7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.44,161.25a8.06,8.06,0,0,0-4.75,1.55,12.1,12.1,0,0,0-11.34-16.35,12,12,0,0,0-5.69,1.42,12.11,12.11,0,0,0-23.45,4.25,12.35,12.35,0,0,0,.12,1.62,11.91,11.91,0,0,0-3.18-.44,12.12,12.12,0,1,0,0,24.23h48.29a8.14,8.14,0,0,0,0-16.28Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "92.131px 158.772px"
    },
    id: "el1fj7nopgzng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.61,122.56a8.15,8.15,0,0,0-4.76,1.54,11.9,11.9,0,0,0,.78-4.23,12.12,12.12,0,0,0-12.12-12.12,12,12,0,0,0-5.68,1.43A12.09,12.09,0,0,0,245.5,115a12.39,12.39,0,0,0-3.18-.43,12.12,12.12,0,1,0,0,24.23h48.29a8.14,8.14,0,0,0,0-16.28Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "264.301px 120.021px"
    },
    id: "elo7z6cv991in",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.6,267.17,301,267l-3.6,4.65.33-5.44-.57-.27a45.55,45.55,0,0,1-.83,6.43,41,41,0,0,1-2.76,5.06s-2.07-2.58-2.22-3.64c-.31-2.11,2.18-8.23,2.18-8.23l-.82,0-2.62,6.35a10.52,10.52,0,0,1-1.38-2.48c-.23-1.08.61-4.37.61-4.37l-.78-.25-.89,4.23-5.19-2.51-.5.4a36.29,36.29,0,0,1,5.3,3.5c1.71,1.78,3.86,6.43,4.39,8.83,1.21,5.52-.67,22.57-.67,22.57h5.51s-2-17.54-1.08-23.3a36.54,36.54,0,0,1,2.1-5.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "291.78px 283.32px"
    },
    id: "elemkl9kyuy6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.69,255.32h0A8,8,0,0,1,282,252a8.1,8.1,0,0,1,15.55-3.17,8.13,8.13,0,0,1,5.7,6.54h.09a8.11,8.11,0,1,1-7.21,11.79,5.61,5.61,0,0,1-2.31.51,5.49,5.49,0,0,1-3.58-1.32,8.1,8.1,0,1,1-7.56-11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "293.022px 257.75px"
    },
    id: "elin2ed8k1dam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24,213.06l-.6-.18L253,217.53l.33-5.44-.57-.27a45.55,45.55,0,0,1-.83,6.43,39.72,39.72,0,0,1-2.76,5.06s-2.07-2.58-2.22-3.64c-.31-2.11,2.18-8.23,2.18-8.23l-.82,0-2.62,6.35a10.52,10.52,0,0,1-1.38-2.48c-.22-1.08.61-4.37.61-4.37l-.78-.25-.89,4.23-5.19-2.51-.49.4a36.84,36.84,0,0,1,5.3,3.5c1.7,1.78,3.85,6.43,4.38,8.83,1.21,5.52-.66,22.57-.66,22.57h5.5s-2-17.55-1.08-23.3a36.54,36.54,0,0,1,2.1-5.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "247.405px 229.2px"
    },
    id: "elltyuyrpweva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,201.21h0a8,8,0,0,1-.71-3.32,8.1,8.1,0,0,1,15.55-3.17,8.12,8.12,0,0,1,5.7,6.54H259A8.11,8.11,0,1,1,251.78,213a5.61,5.61,0,0,1-2.31.51,5.51,5.51,0,0,1-3.58-1.32,8.1,8.1,0,1,1-7.55-11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "248.685px 203.64px"
    },
    id: "elzteyr27uuv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66,329.07l.61-.19,3.6,4.65-.33-5.44.57-.27a45.37,45.37,0,0,0,.83,6.43,41,41,0,0,0,2.76,5.06s2.07-2.58,2.22-3.63c.31-2.11-2.18-8.24-2.18-8.24l.82.05,2.62,6.35a10.52,10.52,0,0,0,1.38-2.48C85.79,330.28,85,327,85,327l.78-.25.89,4.23,5.19-2.51.5.4a36.29,36.29,0,0,0-5.3,3.5c-1.71,1.78-3.86,6.42-4.39,8.83-1.21,5.51.66,22.56.66,22.56h-5.5s2-17.54,1.08-23.29a36.09,36.09,0,0,0-2.1-5.46Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "82.51px 345.255px"
    },
    id: "elpnddombqd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,317.22h0a8.1,8.1,0,1,0-14.84-6.49,8.12,8.12,0,0,0-5.7,6.53h-.09a8.1,8.1,0,1,0,7.21,11.79,5.6,5.6,0,0,0,2.31.5A5.49,5.49,0,0,0,84,328.24a8.1,8.1,0,1,0,7.56-11Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "81.2512px 319.597px"
    },
    id: "ela30wgf0plsl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    className: "animable",
    style: {
      transformOrigin: "245.18px 412.39px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "245.18px 412.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-1",
    className: "animable animator-active",
    style: {
      transformOrigin: "336.119px 247.064px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,366.19c3.15-5.34,2.93-11.47-.83-14.58a8.41,8.41,0,0,0-5.55-1.81c.22-5.18-1.47-9.9-5.15-12.93-5.09-4.2-12.65-4.05-19.51-.31-7.91-11.38-20.87-16.29-30.1-11a16.82,16.82,0,0,0-7,8.07c-13.24-4.7-26.84-1-31.16,8.88a16.24,16.24,0,0,0-1.25,8.17c-3.88-.82-7.6.06-9.8,2.72-2.73,3.32-2.3,8.41.64,12.75Z",
    style: {
      fill: "current",
      transformOrigin: "340.008px 344.811px"
    },
    id: "elu5hl4c2s5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6ufdc2owarb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,366.19c3.15-5.34,2.93-11.47-.83-14.58a8.41,8.41,0,0,0-5.55-1.81c.22-5.18-1.47-9.9-5.15-12.93-5.09-4.2-12.65-4.05-19.51-.31-7.91-11.38-20.87-16.29-30.1-11a16.82,16.82,0,0,0-7,8.07c-13.24-4.7-26.84-1-31.16,8.88a16.24,16.24,0,0,0-1.25,8.17c-3.88-.82-7.6.06-9.8,2.72-2.73,3.32-2.3,8.41.64,12.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "340.008px 344.811px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255,213.86a24.87,24.87,0,0,0,43.51,16.5,24.87,24.87,0,0,0,43.51-3.17c.75.07,1.51.12,2.28.12a24.8,24.8,0,0,0,9.49-1.89,24.85,24.85,0,0,0,37.95,10.07,24.89,24.89,0,1,0,14.71-47.55c0-.34.05-.67.05-1A13.44,13.44,0,0,0,399.38,175a24.91,24.91,0,0,0-17.75-21.41,13.43,13.43,0,0,0-7.15-19.78,13.42,13.42,0,0,0-24.09-6.31,13.17,13.17,0,0,0-2.68-.27,13.45,13.45,0,0,0-13.45,13.45,13.59,13.59,0,0,0,.34,2.94,13.74,13.74,0,0,0-3.71-.53,13.4,13.4,0,0,0-8.54,3.06,13.44,13.44,0,0,0-24.26,8,13.68,13.68,0,0,0,.32,2.89,13.42,13.42,0,0,0-6.1,3.55,13.72,13.72,0,0,0-3.87-.57,13.44,13.44,0,0,0-9.21,23.23A13.41,13.41,0,0,0,278,189a.34.34,0,0,0,0,.1A24.88,24.88,0,0,0,255,213.86Z",
    style: {
      fill: "current",
      transformOrigin: "339.687px 181.904px"
    },
    id: "elaf604kjidjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln8q28kla4o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,213.86a24.87,24.87,0,0,0,43.51,16.5,24.87,24.87,0,0,0,43.51-3.17c.75.07,1.51.12,2.28.12a24.8,24.8,0,0,0,9.49-1.89,24.85,24.85,0,0,0,37.95,10.07,24.89,24.89,0,1,0,14.71-47.55c0-.34.05-.67.05-1A13.44,13.44,0,0,0,399.38,175a24.91,24.91,0,0,0-17.75-21.41,13.43,13.43,0,0,0-7.15-19.78,13.42,13.42,0,0,0-24.09-6.31,13.17,13.17,0,0,0-2.68-.27,13.45,13.45,0,0,0-13.45,13.45,13.59,13.59,0,0,0,.34,2.94,13.74,13.74,0,0,0-3.71-.53,13.4,13.4,0,0,0-8.54,3.06,13.44,13.44,0,0,0-24.26,8,13.68,13.68,0,0,0,.32,2.89,13.42,13.42,0,0,0-6.1,3.55,13.72,13.72,0,0,0-3.87-.57,13.44,13.44,0,0,0-9.21,23.23A13.41,13.41,0,0,0,278,189a.34.34,0,0,0,0,.1A24.88,24.88,0,0,0,255,213.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "339.687px 181.904px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255,213.86a24.75,24.75,0,0,1,3.41-12.53A9.55,9.55,0,0,1,261.4,205a13.69,13.69,0,0,1,18.7,11.93,9.6,9.6,0,0,1,10,.35A9.62,9.62,0,0,1,299.6,209a9.46,9.46,0,0,1,3.25.58,17.76,17.76,0,0,1,20.29-3.91,17.85,17.85,0,0,1,33-.45,17.7,17.7,0,0,1,17.93,3.16,9.61,9.61,0,0,1,15.79,6.31A9.61,9.61,0,0,1,405.63,220a9.61,9.61,0,0,1,16.85,1.38,24.89,24.89,0,0,1-30.7,14.07,24.85,24.85,0,0,1-37.95-10.07,24.8,24.8,0,0,1-9.49,1.89c-.77,0-1.53-.05-2.28-.12a24.87,24.87,0,0,1-43.51,3.17A24.87,24.87,0,0,1,255,213.86Z",
    style: {
      fill: "current",
      transformOrigin: "338.74px 218.045px"
    },
    id: "elf0mvrls4bdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluelbexs0zoh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,213.86a24.75,24.75,0,0,1,3.41-12.53A9.55,9.55,0,0,1,261.4,205a13.69,13.69,0,0,1,18.7,11.93,9.6,9.6,0,0,1,10,.35A9.62,9.62,0,0,1,299.6,209a9.46,9.46,0,0,1,3.25.58,17.76,17.76,0,0,1,20.29-3.91,17.85,17.85,0,0,1,33-.45,17.7,17.7,0,0,1,17.93,3.16,9.61,9.61,0,0,1,15.79,6.31A9.61,9.61,0,0,1,405.63,220a9.61,9.61,0,0,1,16.85,1.38,24.89,24.89,0,0,1-30.7,14.07,24.85,24.85,0,0,1-37.95-10.07,24.8,24.8,0,0,1-9.49,1.89c-.77,0-1.53-.05-2.28-.12a24.87,24.87,0,0,1-43.51,3.17A24.87,24.87,0,0,1,255,213.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "338.74px 218.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,218.86l2.6-.79,15.51,20-1.44-23.41,2.46-1.16s1.42,21,3.58,27.66c1.91,5.9,11.87,21.77,11.87,21.77s8.89-11.1,9.55-15.64c1.32-9.06-9.39-35.42-9.39-35.42l3.56.18L349.7,239.4s5.23-7.2,5.95-10.69c1-4.64-2.63-18.8-2.63-18.8l3.37-1.08,3.82,18.22,22.34-10.8,2.12,1.7S366.59,228.08,361.86,233c-7.33,7.66-16.59,27.64-18.86,38-5.2,23.71,2.86,97.06,2.86,97.06H322.17s8.66-75.46,4.66-100.22c-1-6.21-9-23.49-9-23.49Z",
    style: {
      fill: "current",
      transformOrigin: "342.415px 288.445px"
    },
    id: "el4menyfozt1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb8atiqvdgv4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.16,218.86l2.6-.79,15.51,20-1.44-23.41,2.46-1.16s1.42,21,3.58,27.66c1.91,5.9,11.87,21.77,11.87,21.77s8.89-11.1,9.55-15.64c1.32-9.06-9.39-35.42-9.39-35.42l3.56.18L349.7,239.4s5.23-7.2,5.95-10.69c1-4.64-2.63-18.8-2.63-18.8l3.37-1.08,3.82,18.22,22.34-10.8,2.12,1.7S366.59,228.08,361.86,233c-7.33,7.66-16.59,27.64-18.86,38-5.2,23.71,2.86,97.06,2.86,97.06H322.17s8.66-75.46,4.66-100.22c-1-6.21-9-23.49-9-23.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "342.415px 288.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,372.05c4.25-8,3.09-17.27-3.17-22a13.41,13.41,0,0,0-2.89-1.64c.26-3.71-.85-7-3.45-9a8.73,8.73,0,0,0-5.6-1.64c2.1-10.64-1.68-20.53-9.38-23.16-8.7-3-19.1,4.47-23.23,16.6v0a8.27,8.27,0,0,0-9.89,2.53c-6.22-4.67-13.63-5.63-18.3-1.79-4.12,3.39-5,9.59-2.82,15.82a13.61,13.61,0,0,0-5.76,2.78c-5.87,4.82-6.72,13.79-2.54,21.41Z",
    style: {
      fill: "current",
      transformOrigin: "293.944px 342.999px"
    },
    id: "el4vz8hs490ms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8kqicp418kw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.5,372.05c4.25-8,3.09-17.27-3.17-22a13.41,13.41,0,0,0-2.89-1.64c.26-3.71-.85-7-3.45-9a8.73,8.73,0,0,0-5.6-1.64c2.1-10.64-1.68-20.53-9.38-23.16-8.7-3-19.1,4.47-23.23,16.6v0a8.27,8.27,0,0,0-9.89,2.53c-6.22-4.67-13.63-5.63-18.3-1.79-4.12,3.39-5,9.59-2.82,15.82a13.61,13.61,0,0,0-5.76,2.78c-5.87,4.82-6.72,13.79-2.54,21.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "293.944px 342.999px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlight--inject-1",
    className: "animable",
    style: {
      transformOrigin: "137.76px 245.016px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.9,370.85h-7V147a22.75,22.75,0,0,1,22.73-22.73h6.18v7h-6.18A15.75,15.75,0,0,0,107.9,147Z",
    style: {
      fill: "current",
      transformOrigin: "115.355px 247.56px"
    },
    id: "elo020k0w3oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltxfuz6r90mj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "115.355px 247.56px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elakpbq5v7njl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.9,370.85h-7V147a22.75,22.75,0,0,1,22.73-22.73h6.18v7h-6.18A15.75,15.75,0,0,0,107.9,147Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "115.355px 247.56px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,132.84H124.23l1.15-7.6a5.87,5.87,0,0,1,4.94-4.93c3.32-.49,7.67-1.08,9.71-1.12,5.95-.13,20.66,1.41,27.84,2.22a5.84,5.84,0,0,1,5,4.43Z",
    style: {
      fill: "current",
      transformOrigin: "149.425px 126.011px"
    },
    id: "elukxxj889q2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt6d6mfbtxec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.62,132.84H124.23l1.15-7.6a5.87,5.87,0,0,1,4.94-4.93c3.32-.49,7.67-1.08,9.71-1.12,5.95-.13,20.66,1.41,27.84,2.22a5.84,5.84,0,0,1,5,4.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "149.425px 126.011px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.29,138.16H129.55a5.32,5.32,0,0,1-5.32-5.32h50.39A5.33,5.33,0,0,1,169.29,138.16Z",
    style: {
      fill: "current",
      transformOrigin: "149.425px 135.5px"
    },
    id: "el99fi94zdfwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt4g2lfiqc6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.29,138.16H129.55a5.32,5.32,0,0,1-5.32-5.32h50.39A5.33,5.33,0,0,1,169.29,138.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "149.425px 135.5px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hydrant--inject-1",
    className: "animable",
    style: {
      transformOrigin: "144.115px 334.648px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.4,324.89h-.66v-7.2h-4.8v2.08H129.29v-2.08h-4.8v7.2h-.67a1.74,1.74,0,0,0-1.73,1.74V328a1.74,1.74,0,0,0,1.73,1.74h.67v7.2h4.8v-2.08h29.65v2.08h4.8v-7.2h.66a1.74,1.74,0,0,0,1.74-1.74v-1.32A1.74,1.74,0,0,0,164.4,324.89Z",
    style: {
      fill: "current",
      transformOrigin: "144.115px 327.315px"
    },
    id: "elgop6nj7nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7h9o475vho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.4,324.89h-.66v-7.2h-4.8v2.08H129.29v-2.08h-4.8v7.2h-.67a1.74,1.74,0,0,0-1.73,1.74V328a1.74,1.74,0,0,0,1.73,1.74h.67v7.2h4.8v-2.08h29.65v2.08h4.8v-7.2h.66a1.74,1.74,0,0,0,1.74-1.74v-1.32A1.74,1.74,0,0,0,164.4,324.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "144.115px 327.315px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,310.49h-.94v-.23a9.26,9.26,0,1,0-18.51,0v.23h-1a2.41,2.41,0,0,0-2.4,2.4h0a2.4,2.4,0,0,0,2.4,2.4h1v46.92h18.51V315.29h.94a2.4,2.4,0,0,0,0-4.8Z",
    style: {
      fill: "current",
      transformOrigin: "144.085px 331.453px"
    },
    id: "el8u9iisjpg7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellj14d76moim"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.31,310.49h-.94v-.23a9.26,9.26,0,1,0-18.51,0v.23h-1a2.41,2.41,0,0,0-2.4,2.4h0a2.4,2.4,0,0,0,2.4,2.4h1v46.92h18.51V315.29h.94a2.4,2.4,0,0,0,0-4.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "144.085px 331.453px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkgrwt2wah5o"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.49,
    y: 317.69,
    width: 4.8,
    height: 19.2,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "126.89px 327.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkotrgf2ikb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.94,
    y: 317.69,
    width: 4.8,
    height: 19.2,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "161.34px 327.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,359.11h12.9a6.15,6.15,0,0,1,6.15,6.15v3.34a0,0,0,0,1,0,0h-25.2a0,0,0,0,1,0,0v-3.34A6.15,6.15,0,0,1,137.66,359.11Z",
    style: {
      fill: "current",
      transformOrigin: "144.11px 363.855px"
    },
    id: "elm7hnk8olucc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4hvtfyygtfj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.66,359.11h12.9a6.15,6.15,0,0,1,6.15,6.15v3.34a0,0,0,0,1,0,0h-25.2a0,0,0,0,1,0,0v-3.34A6.15,6.15,0,0,1,137.66,359.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "144.11px 363.855px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elq5y648f935"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.11,319.34a7.92,7.92,0,1,0,7.92,7.92A7.93,7.93,0,0,0,144.11,319.34Zm0,9.8a1.89,1.89,0,1,1,1.89-1.88A1.88,1.88,0,0,1,144.11,329.14Z",
    style: {
      opacity: 0.1,
      transformOrigin: "144.11px 327.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4azaoot0suh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "144.115px 348.085px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.08,339.49h0a2.39,2.39,0,0,1,2.4,2.39v12.4a2.39,2.39,0,0,1-2.4,2.4h0a2.39,2.39,0,0,1-2.39-2.4v-12.4A2.39,2.39,0,0,1,140.08,339.49Z",
    id: "eln66k5bvuchk",
    className: "animable",
    style: {
      transformOrigin: "140.085px 348.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.14,339.49h0a2.39,2.39,0,0,1,2.4,2.39v12.4a2.39,2.39,0,0,1-2.4,2.4h0a2.4,2.4,0,0,1-2.4-2.4v-12.4A2.4,2.4,0,0,1,148.14,339.49Z",
    id: "el23vkuphdnyu",
    className: "animable",
    style: {
      transformOrigin: "148.14px 348.085px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eldu2q7hlrykn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.51,312.89h0a2.41,2.41,0,0,1,2.4-2.4h20.4a2.4,2.4,0,0,1,2.4,2.4h0a2.39,2.39,0,0,1-2.4,2.4h-20.4A2.4,2.4,0,0,1,131.51,312.89Z",
    style: {
      opacity: 0.1,
      transformOrigin: "144.11px 312.89px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pavement--inject-1",
    className: "animable",
    style: {
      transformOrigin: "248.612px 371.797px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.06,382.47h42.6l.71-8.26a11.53,11.53,0,0,0-12.21-12.49l-21.34,1.33a11.52,11.52,0,0,0-10.68,13.2Z",
    style: {
      fill: "current",
      transformOrigin: "377.213px 372.084px"
    },
    id: "elu57c7w3xull",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elixb0q2eig8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.06,382.47h42.6l.71-8.26a11.53,11.53,0,0,0-12.21-12.49l-21.34,1.33a11.52,11.52,0,0,0-10.68,13.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "377.213px 372.084px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,382.47H54.6l-1.15-9.86a9,9,0,0,1,8.54-10l37.79-1.48a9,9,0,0,1,9.2,10.34Z",
    style: {
      fill: "current",
      transformOrigin: "81.2372px 371.797px"
    },
    id: "elfaavftf244i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwoi7c07iar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.25,382.47H54.6l-1.15-9.86a9,9,0,0,1,8.54-10l37.79-1.48a9,9,0,0,1,9.2,10.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "81.2372px 371.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.18,382.47H140.11l-.89-8a11.18,11.18,0,0,1,11.31-12.41l36.39.66a11.18,11.18,0,0,1,10.67,13.73Z",
    style: {
      fill: "current",
      transformOrigin: "168.519px 372.264px"
    },
    id: "elwybzds1rxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkqitiz1oa9n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.18,382.47H140.11l-.89-8a11.18,11.18,0,0,1,11.31-12.41l36.39.66a11.18,11.18,0,0,1,10.67,13.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "168.519px 372.264px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,382.47H102.8l-.89-8.22a7.82,7.82,0,0,1,7.88-8.67L139,366a7.82,7.82,0,0,1,7.6,9.13Z",
    style: {
      fill: "current",
      transformOrigin: "124.287px 374.025px"
    },
    id: "elu8rg0e62vc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsgslvrmp95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.4,382.47H102.8l-.89-8.22a7.82,7.82,0,0,1,7.88-8.67L139,366a7.82,7.82,0,0,1,7.6,9.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "124.287px 374.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,382.47h-42.6l-.71-8.26a11.53,11.53,0,0,1,12.21-12.49l21.34,1.33a11.52,11.52,0,0,1,10.68,13.2Z",
    style: {
      fill: "current",
      transformOrigin: "207.667px 372.084px"
    },
    id: "el7axj65b4fhb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3ucolzifwct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.82,382.47h-42.6l-.71-8.26a11.53,11.53,0,0,1,12.21-12.49l21.34,1.33a11.52,11.52,0,0,1,10.68,13.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "207.667px 372.084px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442,382.47H389.35l-1.15-9.86a9,9,0,0,1,8.54-10l37.79-1.48a9,9,0,0,1,9.2,10.34Z",
    style: {
      fill: "current",
      transformOrigin: "415.987px 371.797px"
    },
    id: "el6n8gaw325wx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elueqm7254rza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442,382.47H389.35l-1.15-9.86a9,9,0,0,1,8.54-10l37.79-1.48a9,9,0,0,1,9.2,10.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "415.987px 371.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.71,382.47h52.65l1.15-9.86a9,9,0,0,0-8.54-10l-37.79-1.48a9,9,0,0,0-9.2,10.34Z",
    style: {
      fill: "current",
      transformOrigin: "339.723px 371.797px"
    },
    id: "elup3v5gm9pe8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfxwknw3f3hc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.71,382.47h52.65l1.15-9.86a9,9,0,0,0-8.54-10l-37.79-1.48a9,9,0,0,0-9.2,10.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "339.723px 371.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.78,382.47h56.07l.89-8a11.18,11.18,0,0,0-11.31-12.41l-36.39.66a11.17,11.17,0,0,0-10.67,13.73Z",
    style: {
      fill: "current",
      transformOrigin: "252.44px 372.264px"
    },
    id: "elk525gvh3y8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltkohia1nb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.78,382.47h56.07l.89-8a11.18,11.18,0,0,0-11.31-12.41l-36.39.66a11.17,11.17,0,0,0-10.67,13.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "252.44px 372.264px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,382.47h42.6l.89-8.22a7.83,7.83,0,0,0-7.88-8.67l-29.25.41a7.82,7.82,0,0,0-7.6,9.13Z",
    style: {
      fill: "current",
      transformOrigin: "296.652px 374.025px"
    },
    id: "el4xycf37aeo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqzun8s6t3v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.56,382.47h42.6l.89-8.22a7.83,7.83,0,0,0-7.88-8.67l-29.25.41a7.82,7.82,0,0,0-7.6,9.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "296.652px 374.025px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    className: "animable",
    style: {
      transformOrigin: "207.528px 281.007px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.13,202.09s3.62,12.27,6.07,16.86,14.6,20.78,14.6,20.78l4.91,1.84,2.1,2.91a2.75,2.75,0,0,1-1,4.16l-2.55,1a2.42,2.42,0,0,1-2.24-.25l-4.39-2.9-1.08-4.36s-14.5-12.58-18.44-21.53-4.75-12.22-4.75-12.22Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "237.87px 225.948px"
    },
    id: "elglraccuvae7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,191.92c1.41,2.08,4,6.89,7.29,17.16l-9.69,7.34s-7.11-9.7-5.55-16.65a14,14,0,0,1,5.32-8.35A1.85,1.85,0,0,1,224.3,191.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.858px 203.747px"
    },
    id: "elfqk7adkzjsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqeqs20mrvhc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.33,208.56a38,38,0,0,0,5.64,4.71l.91-1.44-5.64-18-1.86,8Z",
    style: {
      opacity: 0.5,
      transformOrigin: "225.13px 203.55px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "219.53 215.41 221.68 218.38 233.08 210.04 231.92 205.99 219.53 215.41",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "226.305px 212.185px"
    },
    id: "elabltpkixqcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltlsrj7ui3p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "219.53 215.41 221.68 218.38 233.08 210.04 231.92 205.99 219.53 215.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "226.305px 212.185px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "174.19 371.58 164.57 394.41 168.99 398.69 181.92 376.18 174.19 371.58",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "173.245px 385.135px"
    },
    id: "elpmn2aa8xmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67,325c-.36,1.53-.7,2.91-1,4.11-3.18,12.25-27.75,55.3-27.75,55.3l-8.65-6.92s12.48-40.61,21.1-54.55c0,0,.92-19.68,2-34.92A216.64,216.64,0,0,0,207.67,325Z",
    style: {
      fill: "current",
      transformOrigin: "188.97px 336.215px"
    },
    id: "el54jwm7eq684",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.51 374.46 181.56 384.17 178.21 388.76 167.69 379.9 169.51 374.46",
    style: {
      fill: "current",
      transformOrigin: "174.625px 381.61px"
    },
    id: "el0dtbpf4bf41n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.25 374.19 229.8 404.44 236.69 402.17 231.01 371.54 222.25 374.19",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "229.47px 387.99px"
    },
    id: "elm1sluvb1ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,385.34l-11.23,4.17c-10.57-36.46-15.21-62-15.21-62-.43-.85-.85-1.7-1.26-2.53a216.64,216.64,0,0,1-14.31-37c-1-3.54-1.36-5.49-1.36-5.49-7.81-16.2-3.71-34.31-3.71-34.31l7.68.39h.08l25.78-.05S221,268,216.75,282.91l8.71,38.45Z",
    style: {
      fill: "current",
      transformOrigin: "211.292px 318.845px"
    },
    id: "elr32prpff9hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkdodsosjjx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.37,385.34l-11.23,4.17c-10.57-36.46-15.21-62-15.21-62-.43-.85-.85-1.7-1.26-2.53a216.64,216.64,0,0,1-14.31-37c-1-3.54-1.36-5.49-1.36-5.49-7.81-16.2-3.71-34.31-3.71-34.31l7.68.39h.08l25.78-.05S221,268,216.75,282.91l8.71,38.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "211.292px 318.845px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "222.07 387.8 236.56 382.68 237.01 388.4 224.1 393.01 222.07 387.8",
    style: {
      fill: "current",
      transformOrigin: "229.54px 387.845px"
    },
    id: "el66b5uq602i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,170.32l.51,2.42s-3.83,1.31-.81,4.44c0,0-1.07,5,3.46,3.61,0,0,1.61,3.69,4.54.09s1-10.53,1-10.53l-3.66-6.49-4,4.27Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "201.772px 173.159px"
    },
    id: "elrhbj0eyzyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,157.69l1.56,1.27s3-1.55,3.22,1.63a2.25,2.25,0,0,1,.82,3.83s1.24,5-4,3.21-5.54-8.69-5.54-8.69Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "216.998px 162.854px"
    },
    id: "elftbxbs1ed65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,194.32,187,253.47l35.14,1.43s4.24-33,3.37-59.77a5.43,5.43,0,0,0-5.19-5.31L194.62,189A5.45,5.45,0,0,0,189.09,194.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.314px 221.95px"
    },
    id: "el9bumplrky57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,191a13.46,13.46,0,0,0-.15-1.36l-1.52,0c-1.25-1.54-1.25-3.42-.77-5.34a19.11,19.11,0,0,1,.66-2.11l-4.59-5.27-3.35-3.84c.33,4.75.22,13.27-3.15,16.21l-.87,0c.69,2.07,3,7.46,8.86,7.46,4.31,0,5-3.05,4.88-5.66Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "208.596px 184.915px"
    },
    id: "elnmpi83voc7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcgbb1wv4c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213,184.27c.15-.6.34-1.19.55-1.78l-7-4.9a11.45,11.45,0,0,0,.33,2.61c.52,2.32,3.48,4.51,5.93,5.14A10.62,10.62,0,0,1,213,184.27Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "210.05px 181.465px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,169c1.59,6.24,2.2,10,6,12.73a8.17,8.17,0,0,0,11.59-1.9,8.49,8.49,0,0,0,1.54-4.77c.19-5.89-2.54-15-9.09-16.48a8.32,8.32,0,0,0-10.08,6.06A8.59,8.59,0,0,0,202.3,169Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "211.719px 170.839px"
    },
    id: "elqp2ghbmme1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,170.38c.19.52.62.84,1,.73s.43-.6.27-1.13-.62-.84-1-.73S212.18,169.87,212.38,170.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.006px 170.18px"
    },
    id: "ellhmtxvr6rmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,176.74a.93.93,0,0,0-.39-.37.6.6,0,0,0-.28-.88,1.74,1.74,0,0,0-.93-.1c-.23,0-.23.4,0,.37a2.17,2.17,0,0,1,.51,0c.41.05.52.23.29.61a.2.2,0,0,0,.12.28.89.89,0,0,1,.25.14c.3.27-.07.55-.29.72s0,.47.18.33S220.07,177.21,219.84,176.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.98px 176.621px"
    },
    id: "elpnun4ulvql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25,168.4c.19.52.62.85,1,.73s.46-.62.27-1.13-.62-.83-1-.72S218.06,167.89,218.25,168.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.885px 168.206px"
    },
    id: "elxvs9ro1pbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.51,169.42a17.51,17.51,0,0,0,3.3,3.25,2.64,2.64,0,0,1-2,1Z",
    style: {
      fill: "rgb(213, 135, 69)",
      transformOrigin: "218.16px 171.545px"
    },
    id: "elg0fuuc0yva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.55,169a.29.29,0,0,1-.16,0,.32.32,0,0,1-.2-.41,3.07,3.07,0,0,1,2.06-2,.32.32,0,0,1,.39.23h0a.33.33,0,0,1-.25.39,2.45,2.45,0,0,0-1.6,1.61A.31.31,0,0,1,210.55,169Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.409px 167.796px"
    },
    id: "el9829qim8ox5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,165.06a.27.27,0,0,1-.1-.13.31.31,0,0,1,.22-.39,3.07,3.07,0,0,1,2.86.54.32.32,0,0,1-.43.47,2.45,2.45,0,0,0-2.25-.39A.34.34,0,0,1,217,165.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.475px 165.005px"
    },
    id: "elkx6399i2ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.93,174.74a5.62,5.62,0,0,0,3.13,2.72c1.77.6,2.65-1,2.15-2.74-.45-1.58-1.9-3.77-3.66-3.61S200.13,173.16,200.93,174.74Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "203.471px 174.345px"
    },
    id: "elklikjtaeors",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,170.19s.37,3.6,2.72,3-.19-4.55.68-6a5.81,5.81,0,0,0,.67-5.46c-.92-2-5.16,3.9-5.16,3.9Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "203.018px 167.287px"
    },
    id: "eljexkrcj267",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,213.15l-1.6-16-.14-1.37-.54.05a1.24,1.24,0,0,1-.86,1.48l-.9.1c-1.31.14-2.23,1.72-2.06,3.53s1.39,3.18,2.7,3l.91-.1c.56-.06,1.07.51,1.14,1.28s-.31,1.44-.86,1.5l-.91.1c-1.32.14-2.24,1.74-2.07,3.57s1.4,3.22,2.72,3.08l.92-.1c.56-.06,1.07.52,1.15,1.3l.54-.06Z",
    style: {
      fill: "current",
      transformOrigin: "210.18px 205.175px"
    },
    id: "elcmeu2tlxfpu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86,210.25c.13,1.31.93,2.35,1.75,2.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.735px 211.383px"
    },
    id: "el967165990i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94,200.86c.13,1.29.93,2.31,1.75,2.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.815px 201.973px"
    },
    id: "el5t7c1d16he6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele4uoew7y7v5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.83,201.4l-.52,14.4c10-9.2,10.5-17,10.5-17l-3.68.28Z",
    style: {
      opacity: 0.5,
      transformOrigin: "193.56px 207.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.65,173.26A32.56,32.56,0,0,1,218,158.9s-6.43-10.64-17.18-2.94S198.65,173.26,198.65,173.26Z",
    style: {
      fill: "current",
      transformOrigin: "206.703px 163.211px"
    },
    id: "elfcrhtdqeptu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elefp1qo6287v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.65,173.26A32.56,32.56,0,0,1,218,158.9s-6.43-10.64-17.18-2.94S198.65,173.26,198.65,173.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "206.703px 163.211px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218,158.9s6.65-8.91-2.47-8.05-12.31,16.64-12.31,16.64h0A33.55,33.55,0,0,1,218,158.9Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "211.78px 159.141px"
    },
    id: "elkd7xw2amxvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elziol3g08td"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,158.9s6.65-8.91-2.47-8.05-12.31,16.64-12.31,16.64h0A33.55,33.55,0,0,1,218,158.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "211.78px 159.141px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,257.18h-9.21a2.56,2.56,0,0,1-2.46-2.73l.09-3.54a2.7,2.7,0,0,1,2.59-2.71h9.15a2.56,2.56,0,0,1,2.47,2.71l-.06,3.54A2.68,2.68,0,0,1,183.59,257.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.069px 252.69px"
    },
    id: "el527qlzzwpb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln7z5nzhfj4j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.59,257.18h-9.21a2.56,2.56,0,0,1-2.46-2.73l.09-3.54a2.7,2.7,0,0,1,2.59-2.71h9.15a2.56,2.56,0,0,1,2.47,2.71l-.06,3.54A2.68,2.68,0,0,1,183.59,257.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "179.069px 252.69px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,198.82s-9.21,10.87-10.71,15.93,2.09,28.82,2.09,28.82v5l-.29,2.74a2.41,2.41,0,0,0,2.08,2.38l2.9.31a2.51,2.51,0,0,0,2.66-2.55L183,248l-2-4.55s-.55-24.74.79-27.65S191.74,204,191.74,204Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "182.412px 226.412px"
    },
    id: "elrtzxwgz0ukq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,189.18s-3.24-2.55-16.32,16.43l7.45,7.09s12.68-6.24,13.62-13.88S194.06,189.18,194.06,189.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.327px 200.883px"
    },
    id: "elnwtb192t0v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.54 205.93 184.53 214.29 188.12 212.49 178.1 202.6 175.54 205.93",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.83px 208.445px"
    },
    id: "elj3y9s35lnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzwg568dqwjs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.54 205.93 184.53 214.29 188.12 212.49 178.1 202.6 175.54 205.93",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "181.83px 208.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "186.9 249.27 186.88 250.37 185.85 250.37 185.84 251.41 187.82 251.41 187.86 249.27 186.9 249.27",
    style: {
      fill: "current",
      transformOrigin: "186.85px 250.34px"
    },
    id: "els8rps1zl3j8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfs1o6ok1cub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.77,182.94a22.88,22.88,0,0,1-2.68,9.07c-.89,1.49-1.56,2.44-2.11,3.21a8.78,8.78,0,0,0-1.44,2.55c-.2-7.06-2-10.08-3.67-13a18.8,18.8,0,0,1-2.7-6.41l-.42.08A19.1,19.1,0,0,0,205.5,185c1.85,3.15,3.77,6.42,3.63,15.06-.16,9.15-5.76,17.41-10.75,24.77-2.67,3.94-5.2,7.68-6.67,11.2-4.26,10.19-4.71,13.66-4.72,13.78h.46c0-.11.45-3.49,4.66-13.59,1.46-3.48,4-7.2,6.63-11.12,5-7.41,10.66-15.73,10.82-25a7.42,7.42,0,0,1,1.77-4.63c.55-.77,1.24-1.73,2.13-3.24a23.22,23.22,0,0,0,2.75-9.46Z",
    style: {
      fill: "current",
      opacity: 0.7,
      transformOrigin: "201.6px 214.085px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyg41ytlravn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.77,182.94a22.88,22.88,0,0,1-2.68,9.07c-.89,1.49-1.56,2.44-2.11,3.21a8.78,8.78,0,0,0-1.44,2.55c-.2-7.06-2-10.08-3.67-13a18.8,18.8,0,0,1-2.7-6.41l-.42.08A19.1,19.1,0,0,0,205.5,185c1.85,3.15,3.77,6.42,3.63,15.06-.16,9.15-5.76,17.41-10.75,24.77-2.67,3.94-5.2,7.68-6.67,11.2-4.26,10.19-4.71,13.66-4.72,13.78h.46c0-.11.45-3.49,4.66-13.59,1.46-3.48,4-7.2,6.63-11.12,5-7.41,10.66-15.73,10.82-25a7.42,7.42,0,0,1,1.77-4.63c.55-.77,1.24-1.73,2.13-3.24a23.22,23.22,0,0,0,2.75-9.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "201.6px 214.085px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,179.35h0a.31.31,0,0,1-.37-.24l-.64-3.07a.32.32,0,0,1,.24-.38h0a.3.3,0,0,1,.36.24l.65,3.07A.33.33,0,0,1,203.2,179.35Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "202.814px 177.505px"
    },
    id: "elvvp3wh00ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljk81wn31nyp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.2,179.35h0a.31.31,0,0,1-.37-.24l-.64-3.07a.32.32,0,0,1,.24-.38h0a.3.3,0,0,1,.36.24l.65,3.07A.33.33,0,0,1,203.2,179.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "202.814px 177.505px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.3,175.91a1.51,1.51,0,0,0,0-.67,1.4,1.4,0,0,0-.29-.6,2.36,2.36,0,0,0-1.15-.11,1,1,0,0,0-.76,1.2,1,1,0,0,0,1.17.76A2.39,2.39,0,0,0,204.3,175.91Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "203.206px 175.506px"
    },
    id: "el5o3jdymn1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elntvdzewklzh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.3,175.91a1.51,1.51,0,0,0,0-.67,1.4,1.4,0,0,0-.29-.6,2.36,2.36,0,0,0-1.15-.11,1,1,0,0,0-.76,1.2,1,1,0,0,0,1.17.76A2.39,2.39,0,0,0,204.3,175.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "203.206px 175.506px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.5,169.44l1.39.84-.07-.8-1.38-.84-.23-.08.32,3.91a1.39,1.39,0,0,0-.89-.31c-.6,0-1.06.36-1,.79a1.07,1.07,0,0,0,1.15.79c.6,0,1.06-.35,1-.79h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.262px 171.153px"
    },
    id: "el5q6lpstc9b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.4,156.56l1.56.32-.32-.72-1.56-.32h-.24l1.58,3.52a1.35,1.35,0,0,0-.93,0c-.56.2-.87.68-.69,1.08a1.06,1.06,0,0,0,1.33.35c.56-.21.87-.69.69-1.08h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.854px 158.367px"
    },
    id: "elmh48xmu9n5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.91,155.74l1,1.23.19-.77-1-1.22-.2-.14-.91,3.72a1.3,1.3,0,0,0-.74-.58c-.56-.19-1.1,0-1.21.4s.28.91.85,1.1,1.1,0,1.21-.4h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.061px 157.197px"
    },
    id: "elc5h18qmbxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7,401l-7.76,2.43a.51.51,0,0,0-.37.63l1.54,6.25a1.29,1.29,0,0,0,1.6.86c2.67-.93,3.92-1.46,7.33-2.55a65.51,65.51,0,0,0,9-3.13c2.72-1.36,1.32-4,.05-3.68-3,.79-7.65.13-10.09-.8A2.06,2.06,0,0,0,236.7,401Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "239.077px 406.061px"
    },
    id: "elhwv2k2k2pxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,400.7a1,1,0,0,0-.08-.94.66.66,0,0,0-.52-.34c-1-.08-2.48,1.89-2.65,2.11a.16.16,0,0,0,0,.12.17.17,0,0,0,.18.15,9,9,0,0,0,1.92-.33A2,2,0,0,0,240.71,400.7Zm-.62-.94a.31.31,0,0,1,.25.17.64.64,0,0,1,.07.61c-.2.42-1.12.74-2.43.89C238.61,400.66,239.58,399.73,240.09,399.76Z",
    style: {
      fill: "current",
      transformOrigin: "239.12px 400.609px"
    },
    id: "elt7ml69f14k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,401.75c.56-.63,1.13-2.42.74-3.09a.63.63,0,0,0-.73-.3.83.83,0,0,0-.65.45c-.49.89.3,2.82.33,2.91a.14.14,0,0,0,.12.1.11.11,0,0,0,.07,0A.17.17,0,0,0,237.76,401.75Zm0-3.09c.25,0,.35,0,.38.14a3.38,3.38,0,0,1-.53,2.47,3.8,3.8,0,0,1-.22-2.32.44.44,0,0,1,.3-.25Z",
    style: {
      fill: "current",
      transformOrigin: "237.794px 400.08px"
    },
    id: "elqjxdpr5yxk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.37,396.13l-5.77-5.72a.53.53,0,0,0-.74,0l-4.81,4.29a1.28,1.28,0,0,0,0,1.81c2.07,1.92,3.12,2.79,5.68,5.29a64.89,64.89,0,0,0,7,6.49c2.47,1.77,4.15-.7,3.27-1.68-2.11-2.3-3.69-6.7-4-9.29A2.07,2.07,0,0,0,171.37,396.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.956px 399.586px"
    },
    id: "elslr0cx8csqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,399.52a.93.93,0,0,0,.79-.5.68.68,0,0,0,.06-.62c-.37-.88-2.83-1.31-3.1-1.36a.19.19,0,0,0-.13,0,.17.17,0,0,0,0,.23,8.91,8.91,0,0,0,1.19,1.54A1.9,1.9,0,0,0,173.54,399.52Zm.54-1a.3.3,0,0,1,0,.3.6.6,0,0,1-.51.33c-.45,0-1.18-.64-1.91-1.73C172.59,397.66,173.87,398.08,174.08,398.55Z",
    style: {
      fill: "current",
      transformOrigin: "172.777px 398.274px"
    },
    id: "elrdlb7j6yug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.23,397.41c.81.2,2.67-.14,3.08-.79a.63.63,0,0,0-.08-.79.82.82,0,0,0-.7-.36c-1,0-2.36,1.58-2.42,1.65a.14.14,0,0,0,0,.15.12.12,0,0,0,0,.05A.28.28,0,0,0,171.23,397.41ZM174,396c.15.19.12.33.05.4a3.34,3.34,0,0,1-2.42.68c.46-.48,1.33-1.29,1.94-1.28a.48.48,0,0,1,.36.15Z",
    style: {
      fill: "current",
      transformOrigin: "172.751px 396.468px"
    },
    id: "el79co9roe6r7",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalidas);
export default __webpack_public_path__ + "static/media/salidas.fe202b4b.svg";
export { ForwardRef as ReactComponent };